module.exports = __webpack_public_path__ + "static/media/icon_info_blue.311a411d.svg";